module.exports = __webpack_public_path__ + "img/m-logo.51df3047.png";